import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ExpresionesRegulares from '../../../../util/expresiones-regulares'

const RecipeCodigoSAP = (props) => {
    return (
        <div className="column is-10 is-offset-1">
            <table className="table is-fullwidth">
                    <thead>
                        <tr>
                            <th>Código SAP</th>
                            <th>Unidad SAP</th>
                            <th>Unidad ISO SAP</th>
                        </tr>
                    </thead>
                <tbody>
                    <tr>
                        <td>
                            <input
                                className="input"
                                placeholder="Código SAP"
                                value={props.recetaPresentacion.CodigoSAP || ''}
                                type="text"
                                maxLength={50}
                                onChange={(e) => {
                                    // Eliminar espacios, símbolos y dejar solo letras o números
                                    const valorLimpio = e.target.value
                                    .replace(/[^A-Za-z0-9]/g, '') // quita todo lo que no sea letra o número
                                    .trimStart(); // evita espacios al inicio

                                    // Límite de longitud
                                    const valorFinal = valorLimpio.slice(0, 50);

                                    props.guardarValorInput(valorFinal, 'CodigoSAP');
                                }}
                                />

                        </td>
                        <td>
                            <input
                                className="input"
                                placeholder="Unidad SAP"
                                value={props.recetaPresentacion.UnidadSAP || ''}
                                type="text"
                                maxLength="10"
                                onChange={(e) => {
                                    // Eliminar espacios, símbolos y dejar solo letras o números
                                    const valorLimpio = e.target.value
                                    .replace(/[^A-Za-z0-9]/g, '') // quita todo lo que no sea letra o número
                                    .trimStart(); // evita espacios al inicio

                                    // Límite de longitud
                                    const valorFinal = valorLimpio.slice(0, 10);

                                    props.guardarValorInput(valorFinal, 'UnidadSAP');
                                }}
                            /></td>
                        <td>
                            <input
                                className="input"
                                placeholder="Unidad ISO SAP"
                                value={props.recetaPresentacion.UnidadISOSAP || ''}
                                type="text"
                                maxLength="10"
                                onChange={(e) => {
                                    // Eliminar espacios, símbolos y dejar solo letras o números
                                    const valorLimpio = e.target.value
                                    .replace(/[^A-Za-z0-9]/g, '') // quita todo lo que no sea letra o número
                                    .trimStart(); // evita espacios al inicio

                                    // Límite de longitud
                                    const valorFinal = valorLimpio.slice(0, 10);

                                    props.guardarValorInput(valorFinal, 'UnidadISOSAP');
                                }}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

RecipeCodigoSAP.propTypes = {
    guardarValorInput: PropTypes.func.isRequired,
}

RecipeCodigoSAP.defaultProps = {
    guardarValorInput: () => { },
}

export default RecipeCodigoSAP;
